import { useEffect, useMemo, useRef, useState } from 'react'

export function useAttachmentImageGalleryState({ open, items, initialIndex, subtitle }) {
  const safeLen = items.length
  const initialClamped = Math.min(Math.max(0, initialIndex), Math.max(0, safeLen - 1))
  const [activeIndex, setActiveIndex] = useState(initialClamped)
  const [zoom, setZoom] = useState(1)
  const thumbRefs = useRef({})

  useEffect(() => {
    if (!open || safeLen === 0) return
    thumbRefs.current[activeIndex]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
  }, [activeIndex, open, safeLen])

  useEffect(() => {
    if (!open) return undefined
    const onKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault()
        setZoom(1)
        setActiveIndex((i) => (i > 0 ? i - 1 : i))
      } else if (e.key === 'ArrowRight') {
        e.preventDefault()
        setZoom(1)
        setActiveIndex((i) => (i < safeLen - 1 ? i + 1 : i))
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [open, safeLen])

  const current = items[activeIndex]
  const previewSrc = current?.previewUrl ?? ''
  const canPrev = activeIndex > 0
  const canNext = activeIndex < safeLen - 1

  const resolvedSubtitle = useMemo(() => {
    if (subtitle) return subtitle
    const d = new Date()
    return `Image · ${d.toLocaleDateString(undefined, { weekday: 'long' })} ${d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}`
  }, [subtitle])

  return {
    safeLen,
    activeIndex,
    setActiveIndex,
    zoom,
    setZoom,
    thumbRefs,
    current,
    previewSrc,
    canPrev,
    canNext,
    resolvedSubtitle,
  }
}
